module.exports = __webpack_public_path__ + "img/icon-company.407f26dc.svg";